// extracted by mini-css-extract-plugin
module.exports = {"body":"CreateWhatsappPresetNotificationTemplate_body__18S2V","content_section":"CreateWhatsappPresetNotificationTemplate_content_section__10d3z"};